import React from 'react';
import { Tab } from '@here/hds-tabs';
// eslint-disable-next-line no-new
new Tab();
const HDSTab = React.forwardRef(({ icon, iconCategory, selected, disabled, ariaControls, ariaRole, link, chevron, children, tabPanelId, className, clickAction, externalLink, menu, ...rest }, ref) => (React.createElement("hds-tab", { icon: icon, "aria-controls": ariaControls, ...(ariaRole && { 'aria-role': ariaRole }), ...(tabPanelId && { 'tab-panel-id': tabPanelId }), ...(selected && { selected }), ...(disabled && { disabled }), ...(className && { class: className }), ...(link && { link }), ...(chevron && { chevron }), ...(clickAction && { 'click-action': clickAction }), ...(externalLink && { 'external-link': externalLink }), ...(iconCategory && { 'icon-category': iconCategory }), ref: ref, ...rest },
    children,
    menu && React.createElement("div", { slot: "menu" }, menu))));
HDSTab.defaultProps = {
    icon: '',
    iconCategory: 'core-ui',
    link: false,
    clickAction: false,
    externalLink: false,
    disabled: false,
    ariaControls: undefined,
    ariaRole: 'tab',
    tabPanelId: '',
    selected: false,
};
export default HDSTab;
//# sourceMappingURL=HDSTab.js.map